export default __webpack_public_path__ + "static/media/manual.5b5c711e.pdf";